export const DEFAULT_CHART_PALETTE: string[] = Array.from(
  { length: 13 },
  (_, i) => `var(--chart-multi-lines-hex-${i + 1})`
);

export const DEFAULT_SERIES_PALETTE: string[] = [
  '#ffc53d',
  '#ee518a',
  '#0eb39e',
  '#a39073',
  '#7d66d9',
  '#ff801f',
  '#ec6142',
  '#767d74',
  '#53b365',
  '#ffff57',
  '#3b9eff',
  '#5472e4',
  '#b658c4',
];

const CSS_VAR_NAMES: string[] = DEFAULT_SERIES_PALETTE.map(
  (_, i) => `--chart-multi-lines-hex-${i + 1}`
);

const readCssVar = (el: HTMLElement, name: string): string | null => {
  const v = getComputedStyle(el).getPropertyValue(name).trim();

  return v ? v : null;
};

export const resolveSeriesPalette = (el: HTMLElement): string[] =>
  CSS_VAR_NAMES.map(
    (name, i) => readCssVar(el, name) || DEFAULT_SERIES_PALETTE[i]
  );

export const paletteColorAt = (palette: string[], index: number): string => {
  if (palette.length === 0) {
    // No palette resolved yet (e.g. during the very first render
    // before `resolveSeriesPalette` has run). Fall back to the
    // `currentColor` keyword so canvas/SVG draws use the inherited
    // foreground rather than throwing on `undefined`.
    return 'currentColor';
  }

  // `%` keeps the sign of the dividend, so a negative `index`
  // (legitimate during reordering edge cases) would index out of
  // bounds. Normalise to a non-negative remainder.
  const safeIndex = ((index % palette.length) + palette.length) % palette.length;

  return palette[safeIndex];
};

const CSS_VAR_PATTERN = /var\(\s*(--[^,)\s]+)\s*(?:,\s*([^)]+))?\)/;

export const resolveCssVarColor = (
  el: HTMLElement | null,
  value: string | undefined
): string | undefined => {
  if (!value) {
    return value;
  }

  const match = value.match(CSS_VAR_PATTERN);

  if (!match) {
    return value;
  }

  const [, varName, fallback] = match;

  if (el) {
    const resolved = readCssVar(el, varName);

    if (resolved) {
      return resolved;
    }
  }

  return fallback ? fallback.trim() : value;
};
